import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { SoftSkillEnum } from '@models/profile/soft-skill.enum';

@Component({
  selector: 'profile-i18n-soft-skill',
  templateUrl: './i18n-soft-skill.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class I18nSoftSkillComponent {
  @Input() model: SoftSkillEnum;

  SoftSkillEnum = SoftSkillEnum;
}

@NgModule({
  imports: [CommonModule],
  declarations: [I18nSoftSkillComponent],
  exports: [I18nSoftSkillComponent],
})
export class I18nSoftSkillModule {}
